export default __webpack_public_path__ + "static/media/arts-and-crafts.e5bc66d9.svg";